import { createAnimate, version } from './index';
import { parseScriptOptions } from './core/options';
import type { AnimateInstance } from './core/types';

declare global {
  interface Window {
    Animate?: { create: typeof createAnimate; instance?: AnimateInstance; version: string };
  }
}

const script = document.currentScript as HTMLScriptElement | null;
const api = window.Animate ?? { create: createAnimate, version };
window.Animate = api;

function mount(): void {
  if (!script || api.instance) return;
  try {
    const instance = createAnimate(parseScriptOptions(script));
    api.instance = instance;
    void instance.ready.catch((error) => {
      if (api.instance === instance) api.instance = undefined;
      console.error('[Animate]', error);
    });
  } catch (error) {
    console.error('[Animate]', error);
  }
}

if (document.readyState === 'loading')
  document.addEventListener('DOMContentLoaded', mount, { once: true });
else mount();
